class ApiService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || "/ungegn/api";
  }

  async get(endpoint) {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }

  async post(endpoint, data) {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }

  async put(endpoint, data) {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }

  async delete(endpoint) {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }

  getImageById(id) {
    return `${this.baseUrl}/events/view/${id}`;
  }

  getDocumentById(id) {
    return `${this.baseUrl}/documents/view/${id}`;
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  // Specific endpoints
  getActivities() {
    return this.get("/activities");
  }

  getSliders() {
    return this.get("/sliders");
  }

  getLinks() {
    return this.get("/links");
  }

  getContent() {
    return this.get("/content");
  }

  getEvents() {
    return this.get("/events/");
  }

  getEventBySlug(slug) {
    return this.get(`/events/id/${slug}`);
  }
}

// Create instance THEN export
const apiService = new ApiService();

export default apiService;
